module.exports = __webpack_public_path__ + "static/img/10041.86c342be.png";